import { Card } from "./ui/card";

interface RobotCardProps {
  name: string;
  description: string;
  icon: string;
  image?: string;
  roiMetric?: string;
}

const RobotCard = ({ name, description, icon, image, roiMetric }: RobotCardProps) => {
  return (
    <Card 
      className="border-[hsl(var(--line))] glass-effect p-6 hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-xl"
      style={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)"
      }}
    >
      {image ? (
        <div className="mb-4 rounded-lg overflow-hidden bg-white/5 flex items-center justify-center" style={{ height: "200px" }}>
          <img 
            src={image} 
            alt={`${name} - AI automation robot`} 
            className="w-full h-full object-contain"
            loading="lazy"
            width="300"
            height="200"
          />
        </div>
      ) : (
        <div className="text-4xl mb-3">{icon}</div>
      )}
      <h3 className="font-orbitron font-bold text-lg mb-2">{name}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
      {roiMetric && (
        <div className="mt-3 pt-3 border-t border-[hsl(var(--line))]">
          <p className="text-xs text-primary font-bold">{roiMetric}</p>
        </div>
      )}
    </Card>
  );
};

export default RobotCard;
